module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Light.eot?be4e4c2012a1793ab67421352cf58ba7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Light.eot
// module id = 307
// module chunks = 0